// De cijferreeks van een schaalvraag: van `ReachStart` tot en met `ReachEnd`.
//
// Dit recept stond vier keer in de codebase, met drie gradaties van
// voorzichtigheid: het invulscherm castte wel maar ving een ontbrekende grens
// niet af, de twee formulierschermen deden allebei het juiste, en de printpagina
// deed geen van beide. Eén bron, zodat de vier niet verder uit elkaar lopen.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
//
// TWEE DINGEN GAAN HIER MIS ZONDER POORT.
//
// 1. Zonder `Number()` is `start + idx` een stringplakking: een `ReachStart` die
//    als tekst '1' is opgeslagen — zo schrijft `synchronisationActions.js` hem
//    door — geeft 1, 10, 11, 12, 13 in plaats van 1 t/m 5. Geen fout, geen
//    waarschuwing, gewoon andere cijfers op het scherm.
// 2. Ontbreekt een grens, dan is de lengte `NaN` en gooit `Array(NaN)` een
//    RangeError die de hele pagina meesleurt.
//
// Een lege tekst telt hier als 'geen waarde', niet als 0 — `''` is in deze
// database de opslagvorm van 'nog niets ingevuld'.
// AI-CONTEXT: See docs/pitfalls.md#database-empty-string-is-a-real-stored-value

/**
 * @typedef {object} ScaleRangeOptions
 * @property {number} [fallbackStart] - Grens als `ReachStart` ontbreekt
 * @property {number} [fallbackEnd] - Grens als `ReachEnd` ontbreekt
 */

/**
 * Leest één grens: leeg, null of undefined telt als afwezig en valt terug.
 *
 * @param {*} value - De opgeslagen grens
 * @param {number|undefined} fallback - Waarde bij afwezigheid
 * @returns {number} Het getal, of NaN als er niets bruikbaars is
 */
const readBound = (value, fallback) => {
    const raw = (value === null || value === undefined || value === '') ? fallback : value

    return raw === undefined ? NaN : Number(raw)
}

/**
 * @param {object} field - Een veld met `ReachStart` en `ReachEnd`
 * @param {ScaleRangeOptions} [options] - Terugvalgrenzen voor velden die geen
 *   bereik dragen (`EventFields` worden zonder aangemaakt en tonen 0 t/m 10)
 * @returns {Array<number>} De reeks, of `[]` als het bereik onbruikbaar is —
 *   die vraag toont dan geen cijfers en de rest van de pagina blijft heel
 */
const scaleRange = (field, options = {}) => {
    const start = readBound(field?.ReachStart, options.fallbackStart)
    const end = readBound(field?.ReachEnd, options.fallbackEnd)

    if (!Number.isInteger(start) || !Number.isInteger(end)) return []
    if (end < start) return []

    return Array.from({ length: end - start + 1 }, (_, index) => start + index)
}

export default scaleRange
